import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './services/user.service';
import { bearerTokenFromHeader, parseDdnSession } from './utils/ddn-session';

/**
 * Attach session Bearer token to HttpClient requests that do not already
 * set Authorization (ProductService, invoice services, etc.).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Do not attach Authorization header to external storage / signed upload URLs
  if (
    req.url.includes('storage.googleapis.com') ||
    req.url.includes('googleapis.com/storage') ||
    req.url.includes('amazonaws.com') ||
    req.url.includes('blob.core.windows.net')
  ) {
    return next(req);
  }

  if (bearerTokenFromHeader(req.headers.get('Authorization'))) {
    return next(req);
  }

  const cookieService = inject(CookieService);
  const userService = inject(UserService);
  const fromMemory = userService.getCurrentUser();
  const fromCookie = parseDdnSession(cookieService.get('ddnsession'));
  const token = fromMemory?.token || fromCookie?.token;

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    })
  );
};
